<template>
  <div class="message-card">
    <div class="card-header">
      <div class="user-info">
        <div class="avatar-wrap">
          <div class="status-dot"></div>
          <div class="avatar">
            {{ initials }}
          </div>
        </div>

        <span class="name">{{ name }}</span>
      </div>

      <span class="date">{{ date }}</span>
    </div>

    <div class="message-text">
      {{ message }}
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  name: {
    type: String,
    default: "John Doe"
  },
  date: {
    type: String,
    default: "Aug 12 | 11:00 AM"
  },
  message: {
    type: String,
    default: "As a translator, I want integrate Crowdin webhook to notify translators about changed strings"
  }
});

const initials = computed(() => {
  return props.name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map(word => word[0]?.toUpperCase())
    .join("");
});
</script>

<style scoped>
.message-card {
  width: 100%;
  max-width: 560px;
  background: #ffffff;
  border: 1px solid #aeb1b4;
  border-radius: 0;
  padding: 18px 28px 20px 28px;
  box-sizing: border-box;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
  gap: 16px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.avatar-wrap {
  position: relative;
  width: 34px;
  height: 34px;
  flex-shrink: 0;
}

.avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #d8ebff;
  color: #2d5fb8;
  font-size: 16px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.status-dot {
  position: absolute;
  top: -1px;
  right: -1px;
  width: 9px;
  height: 9px;
  background: #67c96b;
  border: 2px solid #ffffff;
  border-radius: 50%;
  z-index: 1;
}

.name {
  font-size: 14px;
  font-weight: 500;
  color: #6d7b8a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.date {
  font-size: 10px;
  font-weight: 500;
  color: #6d7b8a;
  white-space: nowrap;
  flex-shrink: 0;
}

.message-text {
  padding-left: 46px;
  font-size: 12px;
  line-height: 1.5;
  color: #2f3742;
  max-width: 430px;
}
</style>